import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Modal, Form, message, Input } from 'antd'

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import { changeSalaryLedger, selectSalaryLedger } from "../../actions/salary-allowance-actions";
import salaryLedgerService from "../../services/SalaryAllowance/salary-ledger-service";
import commonService from '../../services/Common/common-service'
import moment from 'moment'

const { Search } = Input

class SalaryLedger extends ReduxAbstract {

	initReload = true
	deleteRowSelection = true
	moduleName = "salaryAllowance"
	childModuleName = "salaryLedger"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		passwordModalStatus:true,
		importModalStatus: false
	}

	actions = {
		changeAction: this.props.changeSalaryLedger,
		selectAction: this.props.selectSalaryLedger,
		createAction: salaryLedgerService.createSalaryLedger,
	}

	headerColumn = [{
			title: "新建月度",
			icon: "plus-circle-o",
			access: "c_value",
			click: () => this.setState({
				currentModalStatus: true,
				currentDataStatus: "loaded",
				currentData: {},
				currentIndex: null,
			})
		}
	]

	tableColumn = [{
			title: '月度台账',
			dataIndex: 'account_monthly',
			key: 'account_monthly',
			className: 'table-global-head-short'
		},{
			title: '名称',
			dataIndex: 'account_name',
			key: 'account_name',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return (
					<div>
					<span>
						<Link to={"/salary-allowance/salary-ledger/" + record.id}>
							<Button icon="edit" size="small" className="row-action-btn">查看</Button>
						</Link>
					</span>
						<span>
						<Link to={"/salary-allowance/salary-addition/" + record.id}>
							<Button icon="edit" size="small" className="row-action-btn">其他数据</Button>
						</Link>
					</span>
					</div>
				);
			}
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "查看",
			click: this.props.history.push("/salary-allowance/salary-ledger/" + record.id)
		}
	]

	formColumn = () => [{
		label: "选择月份",
		key: "account_monthly",
		type: "month",
		span: 24
	}]

	customCreate = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			let year = values.account_monthly.format("YYYY")
			const month = values.account_monthly.format("MM")
			const currentMonth = moment().month() + 1
			if (currentMonth === 1 && month === '12') {
				year = values.account_monthly.add(-1, 'year').format("YYYY")
			}
			const submitData = {
				account_monthly: `${year}-${month}`
			}
			this.publicCreate(submitData);
		}
	})

	togglePasswordModal = (text) => {
		commonService.checkSecondPassword({ Password : text }, (response) => {
			if (response.data.Success) {
				this.setState({
					passwordModalStatus: !this.state.passwordModalStatus
				})
			} else {
				message.error('密码错误', 4)
			}
		})
	}

	goBack = () => {
		this.props.history.goBack()
	}

	count = ()=>{
		let { time } = this.state
		let siv = setInterval(() => {
			this.setState({ time: (time--) }, () => {
				if (time <= -1) {
					clearInterval(siv)
					this.setState({ loading: false, time: 59 })
				}
			})
		}, 1000)
	}

	sendSms = (e) => {
		e.preventDefault()
		commonService.sendSms({ mobile: '15921098897' }, (response) => {
			if (response.data.Success) {
				this.setState({ loading: true })
				if (this.state.time !== 0) {
					this.count()
				}
				message.success('发送成功')
			} else {
				message.error('发送失败')
			}
		})
	}

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
				</div>
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="薪资台账"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.customCreate} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<Modal width='300px'
					   visible={this.state.passwordModalStatus}
					   title="页面已锁定"
					   destroyOnClose={true}
					   onCancel={this.goBack}
					   footer={null}>
					<div className="app-module-header">
						<Form>
							<Form.Item>
								<Search
									placeholder="请输入二级密码"
									enterButton="确认"
									size="large"
									type="password"
									onSearch={text=>this.togglePasswordModal(text)}
								/>
							</Form.Item>
						</Form>
					</div>
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.props[this.moduleName][this.childModuleName].dataStatus}
						dataSource={this.props[this.moduleName][this.childModuleName].data.Data}
						pagination={{
							total: this.props[this.moduleName][this.childModuleName].data.Total,
							pageSize: this.props[this.moduleName][this.childModuleName].data.PageSize,
							current: this.props[this.moduleName][this.childModuleName].filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.actions.changeAction} />
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
	}
}

const mapDispatchToProps = {
	changeSalaryLedger,
	selectSalaryLedger,
}

SalaryLedger = Form.create()(SalaryLedger);

SalaryLedger = connect(mapStateToProps, mapDispatchToProps)(SalaryLedger);

export default LayoutWrapper(SalaryLedger);





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryLedger.js